type GroupableTag = { name: string; tagGroup: { name: string } };

// Groups tag names by their tag-group name. Group order follows first appearance; tag order
// within a group follows input order.
export const groupTagsByGroupName = (tags: readonly GroupableTag[]): Map<string, string[]> => {
    const grouped = new Map<string, string[]>();
    for (const tag of tags) {
        const existing = grouped.get(tag.tagGroup.name);
        if (existing) {
            existing.push(tag.name);
        } else {
            grouped.set(tag.tagGroup.name, [tag.name]);
        }
    }
    return grouped;
};
